import React from 'react';
import {ACTIVE, BLOCKED, NOT_APPROVED, PAGINATION_DEFAULT_LIMIT, USER_ROLES} from '../../helpers/constants';
import {Button} from 'reactstrap';
import ReactTable from 'react-table';
import moment from 'moment';
import {I18n} from '../../I18n/components/users';
import Pagination from '../Pagination/Pagination';

const UsersList = props => {
	const users = props.users;
	let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
	const tableData = users.map((user, index) => {
		return {
			count_id: firstElementNumber++,
			id: user.id,
			name: user,
			email: user,
			role: USER_ROLES[user.role],
			org: user.companyName || 'none',
			status: user.status,
			lastActivity: user.lastActivity ? moment(user.lastActivity).format('YYYY-MM-DD') : 'none',
			actions: (
				<div className="text-center">
					<Button
						onClick={() => props.onEditUser(user.id)}
						color="inverse"
						size="sm"
						round="true"
						icon="true"
					>
						<i className="fa fa-edit"/>
					</Button>
					<Button
						onClick={() => {props.isOkModalToggle(user.id)}}
						className="ml-1"
						color="danger"
						size="sm"
						round="true"
						icon="true"
					>
						<i className="fa fa-times"/>
					</Button>
				</div>
			),
			login: user.login
		};
	});
	return (
		<div className="user-table MyReactTableClass">
			<ReactTable
				getProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							border: "none",
							padding: "5px"
						}
					};
				}}
				getTheadProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							boxShadow: "none",
							padding: "10px 0",
							fontWeight: "600"
						}
					};
				}}
				getTheadThProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							borderRight: "none"
						}
					};
				}}
				getTdProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							borderRight: "none",
							textAlign: "center"
						}
					};
				}}
				getTrProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							alignItems: "center"
						}
					};
				}}
				getNoDataProps={(state, rowInfo, column, instance) => {
					return {
						style: {
							top: "100%"
						}
					};
				}}
				columns={[
					{
						Header: "#",
						accessor: "count_id",
						sortable: false,
						filterable: false,
						style: {
							textAlign: "left",
							fontSize: "0.8rem",
							textTransform: "lowercase"
						},
						maxWidth: 40
					},
					{
						Header: `${I18n[props.lang].name}`,
						accessor: "name",
						sortable: true,
						filterable: false,
						minWidth: 200,
						style: {
							textAlign: "left",
							fontSize: "0.8rem",
						},
						Cell: row => (
							<div className="user-table__img">
								{/*<img*/}
								{/*	src={row.value.img ? row.value.img : profilephoto}*/}
								{/*	alt="user"*/}
								{/*	className="rounded-circle"*/}
								{/*	width="60"*/}
								{/*/>*/}
								<span>{row.value.name}</span>
							</div>
						)
					},
					{
						Header: `${I18n[props.lang].email}`,
						accessor: "email",
						sortable: false,
						filterable: false,
						minWidth: 200,
						style: {
							textAlign: "left",
							fontSize: "0.8rem",
						},
						Cell: row => (
							<div className="">
								<span>{row.value.email}</span>
							</div>
						)
					},
					{
						Header: `${I18n[props.lang].role}`,
						accessor: "role",
						sortable: false,
						filterable: false,
						maxWidth: 150,
						style: {
							fontSize: "0.8rem",
							textTransform: "lowercase"
						}
					},
					{
						Header: `${I18n[props.lang].company}`,
						accessor: "org",
						sortable: false,
						filterable: false,
						maxWidth: 250,
						style: {
							//textAlign: "left"
							fontSize: "0.8rem",
						},
						show: props.companies && props.companies.length !== 1
					},
					{
						Header: `${I18n[props.lang].status}`,
						accessor: "status",
						sortable: false,
						filterable: false,
						maxWidth: 100,
						style: {
							fontSize: "0.8rem",
							textTransform: "lowercase",
						},
						Cell: row => (
							<span style={{
								background: row.value === BLOCKED ? '#f62d51'
									: row.value === NOT_APPROVED ? '#8898aa'
										: row.value === ACTIVE ? '#57D500' : '#000000',
								padding: "3px 5px",
								borderRadius: "45px",
								color: "#ffffff"
							}}>
								{
									row.value === BLOCKED ? `${I18n[props.lang].statusBlocked}` :
										row.value === NOT_APPROVED ? `${I18n[props.lang].statusBlocked}` :
											row.value === ACTIVE ? `${I18n[props.lang].statusActive}` : `${I18n[props.lang].noStatus}`
								}
							</span>
						)
					},
					{
						Header: `${I18n[props.lang].lastActivity}`,
						accessor: "lastActivity",
						sortable: true,
						filterable: false,
						maxWidth: 100,
						style: {
							fontSize: "0.8rem",
							textTransform: "lowercase"
						}
					},
					{
						Header: "",
						accessor: "actions",
						sortable: false,
						filterable: false,
						maxWidth: 75
					}
				]}
				manualSorting={true}
				onSortedChange={props.sortBy}
				defaultSorted={[{
					id   : props.sortState.id,
					desc : props.sortState.desc,
				}]}
				sort={[{id: props.sortState.id, desc: props.sortState.desc}]}
				PaginationComponent={Pagination}
				nextText={">>"}
				previousText={"<<"}
				//pageSize={50}
				//minRows={0}
				defaultPageSize={-1}
				pageSize={tableData.length}
				// showPaginationBottom={false}
				showPaginationBottom={props.totalPages > 1 ? true : false}
				className="-highlight"
				data={tableData}
				filterable
				// custom paginator settings
				manual
				onPageChange={props.setCurrentPage}
				page={props.currentPage}
				pages={props.totalPages}
			/>
		</div>
	)
};

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/Users/UsersList.js